<div [formGroup]="group" [class.mat-radio-group-block]="field.optionsBlock">
    <div class="checkbox-label-text" *ngIf="field.label"><label>{{field.label}}</label>
    </div>
    <mat-radio-group class="flex gap-4"
                     [ngClass]="{'flex-col': field.vertical, 'flex-row': !field.vertical}"
                     [formControlName]="field.name"
                     [disabled]="field.disabled">
        <ng-container *ngFor="let item of field.options">
            <mat-radio-button
                disableRipple
                [value]="field.optionsName ? item[field.optionsName] : item.value">
                {{item.name}}
            </mat-radio-button>
        </ng-container>
        <ng-container *ngIf="field.massEditing">
            <mat-radio-button
                disableRipple
                value = null>
                {{appService.language_dictionary.system_not_specified_upp_case}}
            </mat-radio-button>
        </ng-container>
    </mat-radio-group>
</div>
